module.exports = __webpack_public_path__ + "img/telegram_icon.4a8344ad.png";